export const USER_DATA = [
    {
        key: 'name',
        label: 'User',
        type: 'text',
        render: (row) =>
            [row.first_name, row.middle_name, row.last_name]
                .filter(Boolean)
                .join(' ')
    },
    {
        key: 'email',
        label: 'Email',
        type: 'text',
    },
    {
        key: 'department',
        label: 'Department',
        type: 'text',
        render: (row) => row?.role?.department
    },
    {
        key: 'role_code',
        label: 'Role',
        type: 'badge',
    },
    {
        key: 'is_active',
        label: 'Status',
        type: 'status',
    },
    {
        key: 'last_login',
        label: 'Last Login',
        type: 'date',
        render: (row) => 
            row?.last_login_info
                ? new Date(row.last_login_info?.updated_at).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                })
                : "-"
    },
    {
        key: 'actions',
        label: 'Actions',
        type: 'actions',
        actions: [
            { key: 'manage-permissions', label: 'Manage Permissions' },
            { key: 'change-role', label: 'Change Role' },
            // { key: 'disable', label: 'Disable User' },
        ],
    }
]


// export const ROLES_DATA = [
//     {
//         key: 'name',
//         label: 'Role Name',
//         type: 'text',
//         // render: (row) => row.role_name
//     },
//     {
//         key: 'code',
//         label: 'Role Code',
//         type: 'text',
//         // render: (row) => row.role_code
//     },
//     {
//         key: 'last_updated_at',
//         label: 'Last Updated At',
//         type: 'date',
//         // render: (row) =>
//         //     row?.last_updated_at
//         //         ? new Date(row.last_updated_at).toLocaleDateString("en-US", {
//         //             month: "short",
//         //             day: "2-digit",
//         //             year: "numeric",
//         //             })
//         //         : "-"
//     },
//     {
//         key: 'is_active',
//         label: 'Status',
//         type: 'status',
//     },
//     {
//         key: 'actions',
//         label: 'Actions',
//         type: 'actions',
//         actions: [
//             { key: 'manage-permissions', label: 'Manage Permissions' },
//         ],
//     }
// ]

export const ROLES_PERMISSIONS_DATA = [
    {
        key: 'role_name',
        label: 'Role Name',
        type: 'text',
    },
    {
        key: 'short_name',
        label: 'Role Code',
        type: 'text',
    },
    // {
    //     key: 'parent_role_id',
    //     label: 'Parent Role ID',
    //     type: 'text',
    // },
    {
        key: 'department',
        label: 'Department',
        type: 'text',
    },
    {
        key: 'updatedAt',
        label: 'Last Updated At',
        type: 'date',
        render: (row) =>
            row?.updatedAt
                ? new Date(row.updatedAt).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                })
                : "-"
    },
    {
        key: 'is_active',
        label: 'Status',
        type: 'status',
    },
    {
        key: 'actions',
        label: 'Actions',
        type: 'actions',
        actions: [
            { key: 'manage-permissions', label: 'Manage Permissions' },
        ],
    }
];

export const ROLES_PERMISSIONS_MANAGEMENT = {
    "create_role": {
        title: "Create New Role",
        permissions: [
            {
                // permission_code: ""
            }
        ],
        // These fields render via FilterFieldRenderer inside CreateModal.jsx as
        // plain form inputs, not filters - hideSearchIcon suppresses the search
        // icon/"Search by ..." placeholder FilterFieldRenderer defaults to for
        // filter search boxes.
        inputFields: [
            {
                key: 'role_name',
                label: 'Role Name',
                type: 'text',
                isMandatory: false,
                isReadOnly: false,
                hideSearchIcon: true,
                placeholder: 'Enter role name'
            },
            {
                key: 'short_name',
                label: 'Short Name',
                type: 'text',
                isMandatory: false,
                isReadOnly: false,
                hideSearchIcon: true,
                placeholder: 'Enter short name',
                validation: (value) => {
                    let regex = /^[A-Z_]+$/;
                    if (!value) return ""; // no error if empty (optional)

                    if (!regex.test(value)) {
                        return "Only capital letters and underscore allowed";
                    }

                    return "";
                }
            },
            // { 
            //     key: 'parent_role_id', 
            //     label: 'Parent Role Id', 
            //     // type: 'number', 
            //     type: 'select',  
            //     // isMandatory: false, 
            //     isMandatory: true, 
            //     isReadOnly: false ,
            //     options: []
            //     // defaultValue: 0
            // },
            // { 
            //     key: 'department', 
            //     label: 'Department', 
            //     type: 'text', 
            //     isMandatory: true 
            // },
            { 
                key: 'department_id', 
                label: 'Department', 
                type: 'select', 
                options: [],
                isReadOnly: false,
                isMandatory: true 
            },
            // { 
            //     key: 'is_active', 
            //     label: 'Active Status', 
            //     type: 'select', 
            //     options: [
            //         { 
            //             key: "yes", 
            //             label: "Yes", 
            //             value: "true" 
            //         },
            //         { 
            //             key: "no", 
            //             label: "No", 
            //             value: "false" 
            //         },
            //     ],
            //     isMandatory: false,
            // },
            // { 
            //     key: 'created_by', 
            //     label: 'Created By', 
            //     type: 'text', 
            //     isReadOnly: true 
            // },
            // { 
            //     key: 'updated_by', 
            //     label: 'Updated By', 
            //     type: 'text', 
            //     isReadOnly: true 
            // },
        ]
    },
}

